import React, { useEffect, useCallback } from 'react';
import { linkToNewGroupDutyTransaction } from '../../../utils/dutyTransactions';
import { Dropdown } from '../../ui-kit';
import { DutyRequestIcon } from '../../../utils/dutyTransactions';
import { formatTimeOnlyShort } from '../../../utils/time';
import moment from 'moment';

const CanvasContextMenu = ({ show, setShow, coordX, coordY, startTime, endTime, groupId, dutyFunctionId }) => {
  const handleClose = useCallback(() => {
    setShow(false);
  }, [setShow]);

  useEffect(() => {
    document.addEventListener('click', handleClose, false);
    return () => {
      document.removeEventListener('click', handleClose, false);
    };
  }, [handleClose]);

  if (!show) return null;

  const params = {
    start_time: moment(startTime).format(),
    end_time: moment(endTime).format(),
    requested_duty_function_ids: [dutyFunctionId]
  };
  const extraShiftRequestPath = linkToNewGroupDutyTransaction('duty_requests', groupId, params);

  return (
    <Dropdown.ContextMenu x={coordX} y={coordY} show={true}>
      <Dropdown.Header>
        {formatTimeOnlyShort(startTime)}-{formatTimeOnlyShort(endTime)}
      </Dropdown.Header>
      <Dropdown.Item onClick={handleClose} href={extraShiftRequestPath} target="_blank" rel="noopener noreferrer">
        <DutyRequestIcon type="duty_request" /> {I18n.t('schedules.standby_duty.actions.duty_request')}
      </Dropdown.Item>
    </Dropdown.ContextMenu>
  );
};

export default CanvasContextMenu;
